module.exports = __webpack_public_path__ + "static/img/jcyy-content-tab-2.1e68267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/chartTexeraJc/jcyy-content-tab-2.png
// module id = wB8t
// module chunks = 34